import { render, staticRenderFns } from "./CatalogueTileImage.vue?vue&type=template&id=243e357e&scoped=true&"
import script from "./CatalogueTileImage.vue?vue&type=script&lang=js&"
export * from "./CatalogueTileImage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueTileImage.vue?vue&type=style&index=0&id=243e357e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e357e",
  null
  
)

export default component.exports